export default "__VITE_ASSET__ClIExSaH__"